import { message } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { API } from '../../../API/API';
import ButtonDefault from '../../../components/ButtonDefault/ButtonDefault';
import FieldNumberFormat from '../../../components/FieldNumberFormat/FieldNumberFormat';
import FieldText from '../../../components/FieldText/FieldText';
import { hideLoadScreen, showLoadScreen } from '../../../components/LoadScreen/LoadScreen';
import PanelBase from '../../../components/PanelBase/PanelBase';
import Warning from '../../../components/Warning/Warning';
import { MessageConst } from '../../../const/MessageConst';
import { UserContext } from '../../../context/UserContext';
import { MarketData } from '../../../MockData/MarketData';

const PaymentPanel = (props) => {

    const { userInfo } = useContext(UserContext);
    const [data, setData] = useState({});

    const getData = () => {
        let tData = {};

        if (props?.id) {
            let tIndex = MarketData?.map(r => r.id?.toString()).indexOf(props?.id?.toString());
            if (tIndex >= 0) {
                tData = MarketData[tIndex];
            }
        }

        setData(tData);
    }

    useEffect(() => {
        getData();
    }, [props?.id]);

    const onActivate = async () => {

        showLoadScreen();
        let tData = {
            companyid: userInfo?.companyid,
            featureid: props?.id
        }
        try {
            await API.post('/api/shared/user-management/feature/add', tData).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retmsg?.length > 0)
                        message.info(response.data.retmsg);
                    else
                        message.success(MessageConst.success);
                    props.onDismiss();
                }
            });
        } finally {
            hideLoadScreen();
        }
    }

    const onDismiss = () => {
        props.onDismiss();
    }

    return (
        <PanelBase
            isOpen={props.isOpen}
            headerText={props.title}
            onDismiss={onDismiss}
            buttons={
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonDefault onClick={onActivate} full text="Идэвхжүүлэх" />
                </div>
            }
        >
            <div>
                <div style={{ marginTop: 16 }}>
                    <FieldText disable={true} title='Банк' keyfield='bank' defaultValue='М-Банк' />
                </div>
                <div style={{ marginTop: 16 }}>
                    <FieldText disable={true} title='Хүлээн авах данс' keyfield='account' defaultValue='9016286496' />
                </div>
                <div style={{ marginTop: 16 }}>
                    <FieldText disable={true} title='Дансны нэр' keyfield='accountname' defaultValue='Дижиталворкс ХХК' />
                </div>
                <div style={{ marginTop: 16 }}>
                    <FieldNumberFormat disabled={true} title='Нэг сарын төлбөр (НӨАТ орсон)' keyfield='price' defaultValue={data?.price} suffix="₮" />
                </div>
                <div style={{ marginTop: 16, marginBottom: 16 }}>
                    <FieldText disable={true} title='Гүйлгээний утга' keyfield='transactionvalue' defaultValue={userInfo?.companyid + "-" + props?.id} />
                </div>
            </div>
            <div>
                {props?.id == 2 && (<Warning value='Төлбөр төлөгдсөний дараа холбогч идэвхжих бөгөөд шинээр цаг бүртгэл үүсгэх цонхонд “timely цаг татах” товч  нэмэгдсэн байх  болно.' />)}
                {props?.id == 7 && (<Warning value='Таны үнэгүй ашиглах 3 удаагийн эрх дууссан байна. Та доорх данс руу төлбөр төлснөөр таны дараагийн 3 удаагийн эрх үүсэх болно. Баярлалаа!' />)}
            </div>
        </PanelBase>
    );
}

export default PaymentPanel;